import { Circle, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';
import { IconType } from 'react-icons';

import {
  EventForRenderFragmentGQLType,
  IngestionActionKeyGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { getIngestionPayloadWithAssert } from 'packages/common-frontend/utils';
import { FiAlertTriangle, FiCheck, FiX } from 'react-icons/fi';

const ingestion: {
  [key in IngestionActionKeyGQLType]: {
    Component: ({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) => React.ReactElement;
    icon: IconType;
    PanelComponent?: ({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) => React.ReactElement;
  };
} = {
  success: {
    Component: function InsertDeliverableItemComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { targetName } = event;
      const payload = getIngestionPayloadWithAssert(event);
      const {
        origin: [originPath],
      } = payload;
      return (
        <Text>
          <strong>{`Successful ${targetName}`}</strong>
          {` of file `}
          <strong>{`${originPath}`}</strong>
        </Text>
      );
    },
    icon: FiCheck,
  },
  failed: {
    Component: function InsertDeliverableItemComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { targetName } = event;
      const payload = getIngestionPayloadWithAssert(event);
      const {
        origin: [originPath],
        failedOps,
      } = payload;
      return (
        <Text>
          <strong>{`${failedOps} failed ${targetName}${
            failedOps > 1 ? 's' : ''
          }`}</strong>
          {` of file `}
          <strong>{`${originPath}`}</strong>
        </Text>
      );
    },
    PanelComponent: function InsertDeliverableItemPanelComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const payload = getIngestionPayloadWithAssert(event);
      const { messages } = payload;
      return messages ? (
        <>
          <Heading as="h6" size="md" mt="35px" mb="10px">
            {`Error Message${messages.length > 1 ? 's' : ''}`}
          </Heading>
          {_.map(messages, (message) => (
            <Flex alignItems="center">
              <Circle size="20px">
                <Icon as={FiAlertTriangle} color="red.300" />
              </Circle>
              <Text>{message}</Text>
            </Flex>
          ))}
        </>
      ) : (
        <Text>No error messages to show for this failed ingestion</Text>
      );
    },
    icon: FiX,
  },
};

export default ingestion;
